import { apiGet, apiPost, apiDelete } from "./client.js";

const BASE = "/api/v1/snapshots";

export const listSnapshots = () => apiGet(BASE).then((d) => d.snapshots || []);
export const getSnapshot = (id) => apiGet(`${BASE}/${id}`);
export const createSnapshot = (name, description) => apiPost(BASE, { name, description });
export const restoreSnapshot = (id) => apiPost(`${BASE}/${id}/restore`, {});
export const deleteSnapshot = (id) => apiDelete(`${BASE}/${id}`);
